import { useEffect } from "react";

import queryString from "query-string";

import useUrlHelper from "../../hooks/urlHelper";
import { useTracker } from "../../hooks/useTracker";
import useTranslation from "../../hooks/useTranslation";

import style from "./DownloadSection.module.css"; // eslint-disable-line

const WindowsButton: React.FC<{ downloadURL: string; preferred: boolean }> = ({ preferred }) => {
  const tracker = useTracker();
  const { t, m } = useTranslation();
  const urlHelper = useUrlHelper();
  const params = queryString.stringify(urlHelper.getQueryParams());

  useEffect(() => {
    const loadBadge = () => {
      return new Promise<void>((resolve, reject) => {
        const windowsBadgeScript = document.createElement("script");
        windowsBadgeScript.setAttribute(
          "src",
          "https://get.microsoft.com/badge/ms-store-badge.bundled.js"
        );
        windowsBadgeScript.addEventListener("load", () => {
          resolve();
        });
        windowsBadgeScript.addEventListener("error", () => {
          reject(new Error("Badge failed to load"));
        });
        document.body.appendChild(windowsBadgeScript);
      });
    };
    loadBadge();
  }, []);

  return (
    <div className={`${style.cell} ${preferred ? style.preferred : ""}`}>
      <div className={style.windowsButtonContainer}>
        <ms-store-badge
          productid="9N4K9QFV4XFC"
          theme="dark"
          style={{
            transform: "scale(0.4) translateY(-75%)",
            position: "absolute",
            top: "0px",
            left: "0px",
          }}
          onClick={() => {
            tracker.trackButtonClick({ elementId: "download-windows" });
          }}
        ></ms-store-badge>
      </div>
      <div className={style.buttonDescription}>
        <span>{t(m.Download.RequiresWindows)}</span>
        <div>
          <a
            rel="noreferrer noopener"
            href={`https://shapr3d.com/ms-store-redirect${params ? `?${params}` : ""} `}
            target="_blank"
          >
            {t(m.Download.DownloadFromShapr3D)}
          </a>
        </div>
        <div>
          <a
            rel="noreferrer noopener"
            href="https://www.shapr3d.com/compatible-devices#win"
            target="_blank"
          >
            {t(m.Download.SeeCompatibleDevices)}
          </a>
        </div>
      </div>
    </div>
  );
};

export default WindowsButton;
